import { PRODUCTTYPES } from "Utils/Constants";
import useSession from "Utils/Hooks/useSession";
import limitincreaseexclamation from "Assets/Img/limitincrease-exclamation.png";

export default function ProductSwitchModal({
  onVipOnlineSubmit,
  onVipPreferredSubmit,
}) {
  const { session } = useSession();
  const patronSelectedProductType = session?.productType;

  return (
    <div className="switch-message">
      {patronSelectedProductType === PRODUCTTYPES.PREFERRED && (
        <>
          <div
            style={{
              width: "10%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <img src={limitincreaseexclamation} alt="limit-increase"></img>
          </div>
          &nbsp;
          <div
            style={{
              width: "90%",
              display: "inline-block",
              textAlign: "auto",
              "padding-left": "5px",
            }}
          >
            Hello! We noticed you're already a VIP Online member. Continue your
            transaction to enjoy personalized spending limits based on each of
            your bank accounts. To enjoy membership benefits and potential
            higher funding limits,{" "}
            {
              <button
                className="button-link click-switch-to-vipp"
                onClick={onVipPreferredSubmit}
              >
                click here to try VIP Preferred ACH.
              </button>
            }
          </div>
        </>
      )}
      {patronSelectedProductType === PRODUCTTYPES.ONLINE && (
        <>
          <div
            style={{
              width: "10%",
              display: "inline-block",
              textAlign: "center",
            }}
          >
            <img src={limitincreaseexclamation} alt="limit-increase"></img>
          </div>
          &nbsp;
          <div
            style={{
              width: "90%",
              display: "inline-block",
              textAlign: "auto",
              "padding-left": "5px",
            }}
          >
            Hello! We noticed you're already a VIP Preferred ACH member.
            Continue your transaction to enjoy your membership benefits and
            potential higher funding limits. To enjoy personalized spending
            limits based on each of your bank accounts,{" "}
            {
              <button
                className="button-link click-switch-to-vipo"
                onClick={onVipOnlineSubmit}
              >
                click here to try VIP Online.
              </button>
            }
          </div>
        </>
      )}
    </div>
  );
}
